import Arthouse from './Arthouse';
import Gardenia from './Gardenia';
import YasRiva from './YasRiva';
import MamshaPalm from './MamshaPalm';

const Locales = {Arthouse, Gardenia, YasRiva, MamshaPalm};
export default Locales;
